import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { push } from 'connected-react-router';
import PropTypes from 'prop-types';

import Datatable, { RELOAD_TABLE_TIME } from '../../components/Datatable/';

import {
  getAllClients,
  removeClients,
  restoreClients
} from '../../redux/actions/clients';
import TableHeader from '../../components/TableHeader';
import ModalRemoveItem from '../../components/ModalRemoveItem';
import ModalRestoreItem from '../../components/ModalRestoreItem';
import searchForPermissions from '../../utils/searchForPermissions';

function List (props) {
  const clients = useSelector(state => state.clients);
  const dispatch = useDispatch();
  const sessionUser = useSelector(state => state.authentications.user);
  const company = sessionUser.company._id;
  const menuPetShop = searchForPermissions(
    'menu',
    'petShop',
    sessionUser.permissionsGroup.permissions
  );
  const currentPermissions = searchForPermissions(
    'submenu',
    props.match.path,
    sessionUser.permissionsGroup.permissions
  );
  const [showTable, setShowTable] = useState(true);
  useEffect(() => {
    if (showTable) {
      setShowTable(false);
      setTimeout(() => setShowTable(true), RELOAD_TABLE_TIME);
    }
  }, [currentPermissions.options]);
  const tableData = clients.data.filter(
    item => item.active || currentPermissions.options.r
  );
  const [showModalRemove, setShowModalRemove] = useState(false);
  const [idItemWillRemove, setIdItemWillRemove] = useState('');
  const [nameItemWillRemove, setNameItemWillRemove] = useState('');
  const handleModalConfirmYesRemove = id => {
    setShowModalRemove(false);
    dispatch(removeClients(id));
  };
  const [showModalRestore, setShowModalRestore] = useState(false);
  const [idItemWillRestore, setIdItemWillRestore] = useState('');
  const [nameItemWillRestore, setNameItemWillRestore] = useState('');
  const handleModalConfirmYesRestore = id => {
    setShowModalRestore(false);
    dispatch(restoreClients({ _id: id, active: true }));
  };

  useEffect(() => {
    dispatch(getAllClients({ company }));
  }, [dispatch]);

  const columns = [
    {
      title: 'Nome Social',
      data: 'socialName',
      render: data => data || '---'
    },
    {
      title: 'Tipo',
      data: 'type',
      render: data => (parseInt(data) === 1 ? 'Física' : 'Juridíca' || '---')
    },
    {
      title: 'Nome Completo',
      data: 'name',
      render: data => data || '---'
    },
    {
      title: 'CPF / CNPJ',
      data: 'typePerson',
      render: (data, type, obj) =>
        parseInt(obj.type) === 1 ? obj.cpf : obj.cnpj || '---'
    },
    {
      title: 'Telefone',
      data: 'phones',
      render: data => {
        return data && data.message
          ? `${data.main} / ${data.message}`
          : data.main || '---';
      }
    },
    {
      title: 'Endereço',
      data: 'address',
      render: data => {
        try {
          if (data) {
            const splited = data.street.split(' - ');
            const str = `${splited[0]}, ${data.number} - ${splited[1]} - ${
              data.zipCode
            }`;
            return str;
          } else {
            return '---';
          }
        } catch (err) {
          console.error(err);
          return '---';
        }
      }
    },
    menuPetShop.enabled
      ? {
        title: 'PETS',
        data: 'pets',
        render: data =>
          data && data[0] ? data.map(item => item.name).join(', ') : '---'
      }
      : undefined,
    {
      title: 'Info. Último Contato',
      data: 'contactsHistory',
      render: data => (data && data[0] ? data[0].content : '---')
    },
    {
      title: 'Último Contato',
      data: 'contactsHistory',
      render: (data, type) => {
        if (data && data[0]) {
          if (type === 'display' || type === 'filter') {
            return new Date(data[0].date).toLocaleString() || '---';
          } else {
            return new Date(data[0].date);
          }
        } else {
          return '---';
        }
      }
    },
    {
      title: 'Último Agendamento Fechado',
      data: 'lastScheduleClose.dateEnd',
      render: (data, type) => {
        if (data) {
          if (type === 'display' || type === 'filter') {
            return new Date(data).toLocaleString() || '---';
          } else {
            return new Date(data);
          }
        } else {
          return '---';
        }
      }
    },
    {
      title: 'Próximo Agendamento Aberto',
      data: 'nextScheduleOpen.dateStart',
      render: (data, type) => {
        if (data) {
          if (type === 'display' || type === 'filter') {
            return new Date(data).toLocaleString() || '---';
          } else {
            return new Date(data);
          }
        } else {
          return '---';
        }
      }
    },
    {
      title: 'Notificações',
      data: 'allowNotifications',
      className: 'no-export',
      render: data =>
        data.toString() === 'false'
          ? '<i class="fa fa-times text-danger">&nbsp;</i>'
          : '<i class="fa fa-check text-success">&nbsp;&nbsp;</i>'
    },
    {
      title: 'Ações',
      data: '_id',
      orderable: false,
      className: 'no-export',
      render: (data, type, obj) => {
        return `
          <div class="btn-group">
          ${
            !(currentPermissions.options.l && currentPermissions.options.u)
              ? ''
              : `<button id="${data}" type="button" title="Editar" class="btn btn-warning button-action button-action-update rounded"><i class="fa fa-edit"></i></button>`
          }
          ${
            !obj.active ||
            !(currentPermissions.options.l && currentPermissions.options.d)
              ? ''
              : `<button id="${data}" type="button" title="Excluir" class="btn btn-danger button-action button-action-delete m-1 rounded"><i class="fa fa-trash"></i></button>`
          }
          ${
            obj.active ||
            !(currentPermissions.options.l && currentPermissions.options.r)
              ? ''
              : `<button id="${data}" type="button" title="Restaurar" class="btn btn-info button-action button-action-restore m-1 rounded"><i class="fas fa-trash-restore-alt"></i></button>`
          }
          </div>`;
      }
    }
  ];

  const buttons = [
    {
      extend: 'copy',
      className: 'btn btn-dark fa fa-copy',
      title: 'Relatorio Copiado',
      exportOptions: {
        columns: 'thead th:not(.no-export)'
      }
    },
    {
      extend: 'excel',
      className: 'btn btn-dark fa fa-file-excel',
      title: 'Relatorio Excel',
      exportOptions: {
        columns: 'thead th:not(.no-export)'
      }
    },
    {
      extend: 'csv',
      className: 'btn btn-dark fa fa-file-csv',
      title: 'Relatorio CSV',
      exportOptions: {
        columns: 'thead th:not(.no-export)'
      }
    },
    {
      extend: 'pdf',
      className: 'btn btn-dark fa fa-file-pdf',
      title: 'Relatorio PDF',
      exportOptions: {
        columns: 'thead th:not(.no-export)'
      }
    },
    {
      extend: 'print',
      className: 'btn btn-dark fa fa-file',
      title: 'Relatorio Print',
      exportOptions: {
        columns: 'thead th:not(.no-export)'
      }
    }
  ];

  const handleUpdateButton = id => {
    const url = '/clients/edit/' + id;
    dispatch(push(url));
  };

  const handleDeleteButton = dataRow => {
    setNameItemWillRemove(dataRow.name);
    setIdItemWillRemove(dataRow._id);
    setShowModalRemove(true);
  };

  const handleRestoreButton = dataRow => {
    setNameItemWillRestore(dataRow.name);
    setIdItemWillRestore(dataRow._id);
    setShowModalRestore(true);
  };

  return (
    <div className="container-fluid">
      <ModalRemoveItem
        showModal={showModalRemove}
        handleModalClose={() => setShowModalRemove(false)}
        handleModalConfirmYes={() =>
          handleModalConfirmYesRemove(idItemWillRemove)
        }
        titleModal={'Confirmação'}
        bodyModal={'Deseja excluir o cliente'}
        nameItemWillRemove={nameItemWillRemove}
      />
      <ModalRestoreItem
        showModal={showModalRestore}
        handleModalClose={() => setShowModalRestore(false)}
        handleModalConfirmYes={() =>
          handleModalConfirmYesRestore(idItemWillRestore)
        }
        titleModal={'Confirmação'}
        bodyModal={'Deseja restaurar o cliente'}
        nameItemWillRestore={nameItemWillRestore}
      />
      <TableHeader
        title={'Clientes'}
        url={'/clients/add'}
        updateList={() => dispatch(getAllClients({ company }))}
        isFetching={clients.isFetching}
        hideAddButton={!currentPermissions.options.c}
        hideUpdateButton={!currentPermissions.options.l}
      />
      {showTable && currentPermissions.options.l && (
        <Datatable
          data={tableData}
          columns={columns.filter(column => column)}
          buttons={buttons}
          handleUpdateButton={handleUpdateButton}
          handleDeleteButton={handleDeleteButton}
          handleRestoreButton={handleRestoreButton}
        />
      )}
    </div>
  );
}

List.propTypes = {
  match: PropTypes.object
};

export default List;
